module.exports = __webpack_public_path__ + "static/media/Casa.04d80888.svg";